import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Login from "../views/Login/Login.vue";
import RenewalList from "../views/Financial/RenewalList.vue";
import ApiList from "../views/ApiData/Index.vue";
import UserList from "../views/Financial/UserList.vue";
import WikiList from "../views/Wiki/WikiList.vue";
import NodeList from "../views/Wiki/NodeList.vue";
import WikiAudit from "../views/Wiki/WikiAudit.vue";
import BindShadow from "../views/Wiki/BindShadow.vue";
import CeShi from "../views/Wiki/CeShi.vue";
import BindCompare from "../views/Wiki/BindCompare.vue";
import WikiManager from "../views/Wiki/WikiManager.vue";
import SaleSmart from "../views/Wiki/saleSmart.vue";
import BindWiki from "../views/Wiki/BindWiki.vue";
import EditRecord from "../views/Wiki/EditRecord.vue";
import MyWiki from "../views/Wiki/MyWiki.vue";
import EditWiki from "../views/Wiki/EditWiki.vue";
import SelfJuge from "../views/KPI/SelfJuge.vue";
import OverdraftList from "../views/Financial/Overdraft.vue";
import TransferAmountList from "../views/Financial/TranferAmount.vue";
import SMSTask from "../views/SMS/SMSTask";
import MyFile from "../views/Structure/MyFile.vue";
import EditUserFile from "../views/Structure/EditUserFile.vue";
import AttendanceList from "../views/Attendance/AttendanceList.vue";
import Attendance from "../views/Attendance/Attendance.vue";
import SchedulingList from "../views/Scheduling/SchedulingList.vue";
import DoneMessage from "../views/Done/DoneMessage.vue";
import Frame from "../views/Organization/Frame.vue";
import AddFrame from "../views/Organization/AddFrame.vue";
import ThirdFrame from "../views/Organization/ThirdFrame.vue";
import EntryUserList from "../views/SysUser/EntryUserList.vue";
import UserInfo from "../views/SysUser/UserInfo.vue";
import LeadOut from "../views/SysUser/LeadOut.vue";
import EditUserInfo from "../views/SysUser/EditUserInfo.vue";
import UserExported from "../views/SysUser/UserExported.vue";
import AddUser from "../views/SysUser/AddUser.vue";
import FlowIndex from "../views/Flow/Index.vue";
import CreateTask from "../views/Flow/CreateTask.vue";
import UserCreate from "../views/Flow/UserCreate.vue";
import UserDeal from "../views/Flow/UserDeal.vue";
import CCUser from "../views/Flow/CCUser.vue";
import UserWaitTask from "../views/Flow/UserWaitTask.vue";
import RemoveUserList from "../views/SysUser/RemoveUserList.vue";
import UserManage from "../views/SysUser/UserManage.vue";
import KPISetting from "../views/KPI/Setting.vue";
import MyKPI from "../views/KPI/MyKPI.vue";
import Refund from "../views/Refund/Refund.vue";
import myRefundList from "../views/Refund/myRefundList.vue";
import myApproveList from "../views/Refund/myApproveList.vue";
import myApproveListYet from "../views/Refund/myApproveListYet.vue";
import ccRefund from "../views/Refund/ccRefund.vue";
import LoadingPage from "../views/LoadingPage.vue";
import JugeByLeader from "../views/KPI/JugeByLeader.vue";
import StaffKPI from "../views/KPI/StaffKPI.vue";
import AuditKPI from "../views/KPI/AuditKPI.vue";
import KPIResult from "../views/KPI/KPIResult.vue";
import BindAuditKPI from "../views/KPI/BindAuditKPI.vue";
import BindAuditKPISet from "../views/KPI/BindAuditKPISet.vue";
import LookKPI from "../views/KPI/LookKPI.vue";
import LookKPIResult from "../views/KPI/LookKPIResult.vue";
import LookKPIScore from "../views/KPI/LookKPIScore.vue";
import PrevKPIitem from "../views/KPI/PrevKPIitem.vue";
import KPIIndex from "../views/KPI/Index.vue";
import UserIndex from "../views/OrderService/UserIndex.vue";
import UserCreateOrderService from "../views/OrderService/UserCreateOrderService.vue";
import UserDealOrderService from "../views/OrderService/UserDealOrderService.vue";
import SetServiceWin from "../views/OrderService/SetServiceWin.vue";
import SetDefaultProblem from "../views/OrderService/SetDefaultProblem.vue";
import initiateRAP from "../views/RAP/initiateRAP.vue";
import myApproveListRAP from "../views/RAP/myApproveListRAP.vue";
import myApproveListYetRAP from "../views/RAP/myApproveListYetRAP.vue";
import myRAPList from "../views/RAP/myRAPList.vue";
import ccRAPList from "../views/RAP/ccRAPList.vue";
import BigPerformance from "../views/KPISetting/BigPerformance.vue";
import ExtraDependencies from "../views/KPISetting/ExtraDependencies.vue";
import PerformanceRelation from "../views/KPISetting/PerformanceRelation.vue";
import Performance from "../views/KPISetting/Performance.vue";
import EditApi from "../views/ApiData/EditApi.vue";
// ****************10-28新增内容******************
import QuotaManage from "../views/KPISetting/QuotaManage";
import NoDetection from "../views/KPISetting/NoDetection";
import SalaryAudit from "../views/salaryinfo/SalaryAudit";
import SalaryDetail from "../views/salaryinfo/SalaryDetail";
import SalaryLogin from "../views/salaryinfo/SalaryLogin";
import SalarySend from "../views/salaryinfo/SalarySend";
// ****************10-29新增内容******************
import SalaryGrade from "../views/SalaryStanded/SalaryGrade";
import SalaryScale from "../views/SalaryStanded/SalaryScale";
import SalarySystem from "../views/SalaryStanded/SalarySystem";
import Job from "../views/SalaryStanded/Job";
import JobCategory from "../views/SalaryStanded/JobCategory";
import SalaryManage from "../views/SalaryStanded/SalaryManage";
import SalaryStructure from "../views/SalaryStanded/SalaryStructure";
import DepartPost from "../views/SalaryStanded/DepartPost";
import HistoryUserKPI from "../views/KPI/HistoryUserKPI";
import KPIScore from "../views/KPI/KPIScore";

import { cryptoDecode } from "../until/encrypt.js";

//产品审批
import FlowProductIndex from "../views/FlowProduct/Index.vue";
import FlowProductCreateTask from "../views/FlowProduct/CreateTask.vue";
import FlowProductUserCreate from "../views/FlowProduct/UserCreate.vue";
import FlowProductUserWaitTask from "../views/FlowProduct/UserWaitTask.vue";
import FlowProductUserDeal from "../views/FlowProduct/UserDeal.vue";
import FlowProductCCUser from "../views/FlowProduct/CCUser.vue";

/**
 * router:客户档案
 * */
// 客户档案列表
import Customer from "@/views/CustomerProfile/Customer.vue";
import Diagnoselist from "@/views/CustomerProfile/Diagnoselist.vue";
import Replay from "@/views/CustomerProfile/Replay.vue";
import CustomerMark from "@/views/CustomerProfile/CustomerMark.vue";

//解决Uncaught (in promise) NavigationDuplicated
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
//
Vue.use(VueRouter);

const routes = [
  //登录后加载页面
  // {path: '/',name:'LoadingPage',component:LoadingPage},
  //#region
  {
    // path: "/home",
    path: "/",
    name: "Home",
    component: Home
  },
  //api添加页面
  {
    path: "/Api/EditApi",
    name: "EditApi",
    component: EditApi
  },
  {
    path: "/testlogin",
    name: "Login",
    component: Login
  },
  //转款列表
  {
    path: "/Financial/RenewalList",
    name: "RenewalList",
    component: RenewalList
  },
  //用户列表
  {
    path: "/Financial/UserList",
    name: "UserList",
    component: UserList
  },
  //接口列表
  {
    path: "/Api/Index",
    name: "ApiList",
    component: ApiList
  },
  //百科列表
  {
    path: "/Wiki/index",
    name: "WikiList",
    component: WikiList
  },
  //百科节点列表
  {
    path: "/Wiki/Node",
    name: "NodeList",
    component: NodeList
  },
  //百科审核
  {
    path: "/Wiki/AuditWikis",
    name: "WikiAudit",
    component: WikiAudit
  },
  //销售锦囊
  {
    path: "/WikiTest/Index3",
    name: "SaleSmart",
    component: SaleSmart
  },
  //百科查看
  {
    path: "/Wiki/BindWiki",
    name: "BindWiki",
    component: BindWiki
  },
  //我的百科
  {
    path: "/Wiki/MyWikisOnEdit",
    name: "MyWiki",
    component: MyWiki
  },
  //百科影子信息
  {
    path: "/Wiki/BindShadow",
    name: "BindShadow",
    component: BindShadow
  },
  //百科详情对比
  {
    path: "/Wiki/BindCompare",
    name: "BindCompare",
    component: BindCompare
  },
  //百科修改记录
  {
    path: "/Wiki/EditRecord",
    name: "EditRecord",
    component: EditRecord
  },
  //百科管理
  {
    path: "/Wiki/Manage",
    name: "WikiManager",
    component: WikiManager
  },
  //测试页面
  {
    path: "/Wiki/CeShi",
    name: "CeShi",
    component: CeShi
  },
  // 退款首页
  {
    path: "/Refund/Refund",
    component: Refund
  },
  // 我发起的申请
  {
    path: "/Refund/myRefundList",
    component: myRefundList
  },
  // 待我审批
  {
    path: "/Refund/myApproveList",
    component: myApproveList
  },
  // 我审批过的
  {
    path: "/Refund/myApproveListYet",
    component: myApproveListYet
  },
  // 抄送我的
  {
    path: "/Refund/ccRefund",
    component: ccRefund
  },
  //透支列表
  {
    path: "/Financial/Overdraft",
    name: "Overdraft",
    component: OverdraftList
  },
  //财务系统加款记录
  {
    path: "/Financial/TransferAmount",
    name: "TransferAmount",
    component: TransferAmountList
  },
  //短信任务
  {
    path: "/SMSTask/Index",
    name: "SMSTask",
    component: SMSTask
  },
  //我的档案
  {
    path: "/Structure/MyFile",
    name: "MyFile",
    component: MyFile
  },
  //补全信息
  {
    path: "/Structure/EditUserFile",
    name: "EditUserFile",
    component: EditUserFile
  },
  //测试页面
  {
    path: "/Wiki/EditWiki",
    name: "EditWiki",
    component: EditWiki
  },
  //考勤列表
  {
    path: "/Attendance/AttendanceList",
    name: "AttendanceList",
    component: AttendanceList
  },
  //考勤查询
  {
    path: "/Attendance/Attendance",
    name: "Attendance",
    component: Attendance
  },
  //休息日列表
  {
    path: "/Scheduling/SchedulingList",
    name: "SchedulingList",
    component: SchedulingList
  },
  //待办事项
  {
    path: "/Done/DoneMessage",
    name: "DoneMessage",
    component: DoneMessage
  },
  //组织架构
  {
    path: "/Organization/Frame",
    name: "Frame",
    component: Frame
  },
  //新增机构
  {
    path: "/Organization/AddFrame",
    name: "AddFrame",
    component: AddFrame
  },
  //第三方组织机构
  {
    path: "/Organization/ThirdFrame",
    name: "ThirdFrame",
    component: ThirdFrame
  },
  //入职管理
  {
    path: "/SysUser/EntryUserList",
    name: "EntryUserList",
    component: EntryUserList
  },
  //人员档案
  {
    path: "/SysUser/UserInfo",
    name: "UserInfo",
    component: UserInfo
  },
  //导出信息
  {
    path: "/SysUser/LeadOut",
    name: "LeadOut",
    component: LeadOut
  },
  //编辑档案
  {
    path: "/SysUser/EditUserInfo",
    name: "EditUserInfo",
    component: EditUserInfo
  },
  //发起入职
  {
    path: "/SysUser/AddUser",
    name: "AddUser",
    component: AddUser
  },
  //发起审批首页
  {
    path: "/Flow/Flow",
    name: "Flow",
    component: FlowIndex
  },
  //创建审批
  {
    path: "/Flow/CreateTask",
    name: "CreateTask",
    component: CreateTask
  },
  //我发起的
  {
    path: "/Flow/UserCreate",
    name: "UserCreate",
    component: UserCreate
  },
  //我已处理的
  {
    path: "/Flow/UserDeal",
    name: "UserDeal",
    component: UserDeal
  },
  //抄送我的
  {
    path: "/Flow/CCUser",
    name: "CCUser",
    component: CCUser
  },
  //待我审批的
  {
    path: "/Flow/UserWaitTask",
    name: "UserWaitTask",
    component: UserWaitTask
  },
  //绩效设置
  {
    path: "/KPI/KPISetting",
    name: "KPISetting",
    component: KPISetting
  },
  //KPI结果
  {
    path: "/KPI/KPIResult",
    name: "KPIResult",
    component: KPIResult
  },
  //离职管理
  {
    path: "/SysUser/RemoveUserList",
    name: "RemoveUserList",
    component: RemoveUserList
  },
  //在职管理
  {
    path: "/SysUser/UserManage",
    name: "UserManage",
    component: UserManage
  },
  //我的KPI
  {
    path: "/KPI/MyKPI",
    name: "MyKPI",
    component: MyKPI
  },
  //自评KPI
  {
    path: "/KPI/SelfJuge",
    name: "SelfJuge",
    component: SelfJuge
  },
  //领导评分
  {
    path: "/KPI/JugeByLeader",
    name: "JugeByLeader",
    component: JugeByLeader
  },
  //员工KPI
  {
    path: "/KPI/StaffKPI",
    name: "StaffKPI",
    component: StaffKPI
  },
  //KPI审核
  {
    path: "/KPI/AuditKPI",
    name: "AuditKPI",
    component: AuditKPI
  },
  //KPI审核查看
  {
    path: "/KPI/BindAuditKPI",
    name: "BindAuditKPI",
    component: BindAuditKPI
  },
  //KPI审核查看设置
  {
    path: "/KPI/BindAuditKPISet",
    name: "BindAuditKPISet",
    component: BindAuditKPISet
  },
  //查看KPI
  {
    path: "/KPI/LookKPI",
    name: "LookKPI",
    component: LookKPI
  },
  //查看KPI结果
  {
    path: "/KPI/LookKPIResult",
    name: "LookKPIResult",
    component: LookKPIResult
  },
  //查看KPI评分
  {
    path: "/KPI/LookKPIScore",
    name: "LookKPIScore",
    component: LookKPIScore
  },
  //复制上月上季度KPI列表
  {
    path: "/KPI/PrevKPIitem",
    name: "PrevKPIitem",
    component: PrevKPIitem
  },
  //绩效管理首页
  {
    path: "/KPI/Index",
    name: "KPIIndex",
    component: KPIIndex
  },
  //#endregion
  //发起工单
  {
    path: "/OrderService/UserIndex",
    name: "UserIndex",
    component: UserIndex
  },
  {
    path: "/OrderService/UserCreateOrderService",
    name: "UserCreateOrderService",
    component: UserCreateOrderService
  },
  {
    path: "/OrderService/UserDealOrderService",
    name: "UserDealOrderService",
    component: UserDealOrderService
  },
  {
    path: "/OrderService/SetServiceWin",
    name: "SetServiceWin",
    component: SetServiceWin
  },
  {
    path: "/OrderService/SetDefaultProblem",
    name: "SetDefaultProblem",
    component: SetDefaultProblem
  },
  //需求审批流程-发起审批
  {
    path: "/RAP/initiateRAP",
    name: "initiateRAP",
    component: initiateRAP
  },
  //需求审批流程-待我审批
  {
    path: "/RAP/myApproveListRAP",
    name: "myApproveListRAP",
    component: myApproveListRAP
  },
  //需求审批流程-我发起的
  {
    path: "/RAP/myRAPList",
    name: "myRAPList",
    component: myRAPList
  },
  //需求审批流程-我已审批
  {
    path: "/RAP/myApproveListYetRAP",
    name: "myApproveListYetRAP",
    component: myApproveListYetRAP
  },
  //需求审批流程-抄送我的
  {
    path: "/RAP/ccRAPList",
    name: "ccRAPList",
    component: ccRAPList
  },
  //大盘绩效     ExtraDependencies
  {
    path: "/KPISetting/BigPerformance",
    name: "BigPerformance",
    component: BigPerformance
  },
  //额外从属关系   PerformanceRelation
  {
    path: "/KPISetting/ExtraDependencies",
    name: "ExtraDependencies",
    component: ExtraDependencies
  },
  //模板对应关系       Performance
  {
    path: "/KPISetting/PerformanceRelation",
    name: "PerformanceRelation",
    component: PerformanceRelation
  },
  //模板页
  {
    path: "/KPISetting/Performance",
    name: "Performance",
    component: Performance
  },
  //指标名称管理
  {
    path: "/KPISetting/QuotaManage",
    name: "QuotaManage",
    component: QuotaManage
  },
  // 不检测列表
  {
    path: "/KPISetting/NoDetection",
    name: "NoDetection",
    component: NoDetection
  }, //SalaryAudit
  {
    //工资审核
    path: "/salaryinfo/salaryaudit",
    name: "SalaryAudit",
    component: SalaryAudit
  },
  //SalaryAudit
  {
    //工资审核
    path: "/salaryinfo/SalaryDetail",
    name: "SalaryDetail",
    component: SalaryDetail
  },
  {
    //工资审核
    path: "/salaryinfo/SalaryLogin",
    name: "SalaryLogin",
    component: SalaryLogin
  },

  {
    //工资审核
    path: "/salaryinfo/SalarySend",
    name: "SalarySend",
    component: SalarySend
  },
  /**
   * 薪资标准
   *
   * */
  // 1)薪级
  {
    path: "/SalaryStandard/SalaryGrade",
    name: "SalaryGrade",
    component: SalaryGrade
  },
  // 2)薪酬档位
  {
    path: "/SalaryStandard/SalaryScale",
    name: "SalaryScale",
    component: SalaryScale
  },

  // 3)薪酬体系
  {
    path: "/SalaryStandard/SalarySystem",
    name: "SalarySystem",
    component: SalarySystem
  },

  // 4)岗位类别
  {
    path: "/SalaryStandard/Job",
    name: "Job",
    component: Job
  },

  // 5)岗位
  {
    path: "/SalaryStandard/JobCategory",
    name: "JobCategory",
    component: JobCategory
  },

  // 6)薪资管理
  {
    path: "/SalaryStandard/SalaryManage",
    name: "SalaryManage",
    component: SalaryManage
  },

  // 7)薪资结构
  {
    path: "/SalaryStandard/SalaryStructure",
    name: "SalaryStructure",
    component: SalaryStructure
  },
  // 8)岗位与部门
  {
    path: "/SalaryStandard/DepartPost",
    name: "DepartPost",
    component: DepartPost
  },
  //员工信息导出
  {
    path: "/SysUser/UserExported",
    name: "UserExported",
    component: UserExported
  },
  //历史总分查看员工KPI详情
  {
    path: "/KPI/HistoryUserKPI",
    name: "HistoryUserKPI",
    component: HistoryUserKPI
  },
  {
    path: "/KPI/KPIScore",
    name: "KPIScore",
    component: KPIScore
  },
  //产品审批   FlowProductIndex
  {
    path: "/FlowProduct/Flow",
    name: "FlowProductIndex",
    component: FlowProductIndex
  },
  {
    path: "/FlowProduct/CreateTask",
    name: "FlowProductCreateTask",
    component: FlowProductCreateTask
  },
  //我发起的
  {
    path: "/FlowProduct/UserCreate",
    name: "FlowProductUserCreate",
    component: FlowProductUserCreate
  }, //待我审批的
  {
    path: "/FlowProduct/UserWaitTask",
    name: "FlowProductUserWaitTask",
    component: FlowProductUserWaitTask
  }, //我已处理的
  {
    path: "/FlowProduct/UserDeal",
    name: "FlowProductUserDeal",
    component: FlowProductUserDeal
  },
  //抄送我的
  {
    path: "/FlowProduct/CCUser",
    name: "FlowProductCCUser",
    component: FlowProductCCUser
  },
  //客户档案列表
  {
    path: "/Customer/List",
    name: "Customer",
    component: Customer
  },
  {
    path: "/Customer/Diagnoselist/:customerid",
    name: "Diagnoselist",
    component: Diagnoselist
  },
  {
    path: "/Customer/Replay/:customerid",
    name: "Replay",
    component: Replay
  },
  {
    path: "/Customer/CustomerMark/:customerid",
    name: "CustomerMark",
    component: CustomerMark
  }
];
const router = new VueRouter({
  mode: "history",
  routes
});
//挂载路由导航守卫
const whiteList = ["/"];
router.beforeEach((to, from, next) => {
  if (whiteList.indexOf(to.path) === -1) {
    let userinfo = cryptoDecode(window.sessionStorage.getItem("userinfo"));
    if (!userinfo || userinfo == "null") {
      window.location.href = process.env.VUE_APP_BASE_REDIRECT_URL;
    }
    next();
  }
  next();
});
export default router;
